export default __webpack_public_path__ + "static/media/DFT-BNB.51143d31.svg";